/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditSteps/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AutodraftAch from './AutodraftAch/index'
import AutodraftCc from './AutodraftCc/index'
import BackAction from './BackAction/index'
import DownpaymentAch from './DownpaymentAch/index'
import DownpaymentCc from './DownpaymentCc/index'
import InHouse from './InHouse/index'
import PayDownpayment from './PayDownpayment/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import SchedulePayment from './SchedulePayment/index'
import SelectPlan from './SelectPlan/index'
import SetupAutodraft from './SetupAutodraft/index'
import SignContract from './SignContract/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import TysiaIconSteps from 'DesignSystem/Svgs/TysiaIconSteps/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function EditSteps({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditSteps"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="EditSteps.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-99U6h': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-2-99U6h': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pl-3-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="EditSteps.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-5-99U6h': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconSteps
  viewPath={`${viewPath}/TysiaIconSteps`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 textTransform="uppercase"
 text="TREATMENT PLAN STEPS"
/>
</div>
</div>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 marginBottom={0}
 marginTop={0}
 backgroundColor={dtColorsNeutral200}
/>
<div
  data-testid="EditSteps.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-3-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-5-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<SelectPlan
  viewPath={`${viewPath}/SelectPlan`}
/>
<SignContract
  viewPath={`${viewPath}/SignContract`}
/>
<PayDownpayment
  viewPath={`${viewPath}/PayDownpayment`}
/>
<SetupAutodraft
  viewPath={`${viewPath}/SetupAutodraft`}
/>
<SchedulePayment
  viewPath={`${viewPath}/SchedulePayment`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Pay downpayment"
/>
<div
  data-testid="EditSteps.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-5-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal2}`}
>
<DownpaymentCc
  viewPath={`${viewPath}/DownpaymentCc`}
/>
<DownpaymentAch
  viewPath={`${viewPath}/DownpaymentAch`}
/>
<InHouse
  viewPath={`${viewPath}/InHouse`}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Setup autodraft"
/>
<div
  data-testid="EditSteps.Horizontal:3"
  data-view-path={viewPath}
 style={{'--g-5-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal3}`}
>
<AutodraftCc
  viewPath={`${viewPath}/AutodraftCc`}
/>
<AutodraftAch
  viewPath={`${viewPath}/AutodraftAch`}
/>
</div>
<div
  data-testid="EditSteps.Horizontal:4"
  data-view-path={viewPath}
 style={{'--g-5-99U6h': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal4}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}